import script from "./FoodfactoryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FoodfactoryPage.vue?vue&type=script&setup=true&lang=js"

import "./FoodfactoryPage.vue?vue&type=style&index=0&id=57110bf6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57110bf6"]])

export default __exports__